import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './App';

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const { user } = useAuth();
  const [balance, setBalance] = useState(0);
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
  const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

  useEffect(() => {
    if (user) {
      fetchWallet();
    }
  }, [user]);

  const fetchWallet = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await axios.get(`${API}/wallet/balance`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBalance(res.data.balance);
      setIsPremium(res.data.is_premium);
    } catch (e) {
      console.error('Failed to fetch wallet', e);
    }
  };

  const recharge = async (amount) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/wallet/recharge`, { amount }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBalance(res.data.balance);
      setIsPremium(res.data.is_premium);
      return { success: true, newBalance: res.data.balance };
    } catch (e) {
      return { success: false, error: e.response?.data?.detail || 'Recharge failed' };
    } finally {
      setLoading(false);
    }
  };

  const withdraw = async (amount, reason) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/wallet/withdraw`, { amount, reason }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBalance(res.data.balance);
      setIsPremium(res.data.is_premium);
      return { success: true, newBalance: res.data.balance };
    } catch (e) {
      return { success: false, error: e.response?.data?.detail || 'Withdraw failed' };
    } finally {
      setLoading(false);
    }
  };

  const recordUsage = async (pageName) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/wallet/record-usage`, { page_name: pageName }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBalance(res.data.balance);
      setIsPremium(res.data.is_premium);
      return { success: true, ...res.data };
    } catch (e) {
      return { success: false, error: e.response?.data?.detail || 'Failed to record usage or insufficient balance' };
    } finally {
      setLoading(false);
    }
  };

  return (
    <WalletContext.Provider value={{ balance, isPremium, recharge, withdraw, recordUsage, loading, fetchWallet }}>
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => useContext(WalletContext);
